// Résolution des icônes de navigation par nom.
//
// Les icônes de la refonte (Icones_navigation/ et Icones_boutons_pages/) ne
// sont pas encore toutes livrées. Un `import` statique d'un PNG absent casse
// le build entier ; require.context permet au contraire de renvoyer null et de
// laisser le bouton s'afficher sans image.
//
// Une fois les icônes déposées dans assets/, rien à changer ici : elles sont
// prises en compte automatiquement.

function creerResolveur(contexte) {
  return function resoudre(nom) {
    if (!nom) return null;
    try {
      return contexte(`./${nom}.png`);
    } catch {
      return null;
    }
  };
}

const contexteNavigation = require.context(
  '../../assets/Icones_navigation',
  false,
  /\.png$/
);

const contexteBoutonsPages = require.context(
  '../../assets/Icones_boutons_pages',
  false,
  /\.png$/
);

export const iconeNavigation = creerResolveur(contexteNavigation);

const resoudreBoutonPage = creerResolveur(contexteBoutonsPages);

/**
 * Icône d'une entrée de sidebar.
 *
 * Les 10 icônes de niveau 3 vivent dans Icones_boutons_pages/, mais l'entrée
 * "Total territoire" réutilise icon_DR_territoire50 qui est rangée dans
 * Icones_navigation/ : on cherche donc dans les deux dossiers.
 */
export function iconeBoutonPage(nom) {
  return resoudreBoutonPage(nom) ?? iconeNavigation(nom);
}
